import { render } from "./BusinessModelSection.vue?vue&type=template&id=0c047f0c&scoped=true"
import script from "./BusinessModelSection.vue?vue&type=script&lang=js"
export * from "./BusinessModelSection.vue?vue&type=script&lang=js"

import "./BusinessModelSection.vue?vue&type=style&index=0&id=0c047f0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c047f0c"]])

export default __exports__